/* ============================================================
   Revam Navbar (GTG-012) — desktop mega-menu behaviour
   Progressive enhancement over the CSS :hover / :focus-within baseline:
   - hover-intent delay (avoids accidental opens on pass-through)
   - aria-expanded sync, single panel open at a time
   - keyboard: focus opens, Esc closes + returns focus, outside click closes
   No jQuery dependency. Idempotent. Vanilla JS.
   ============================================================ */
(function () {
  'use strict';
  if (window.__revamNavbarInit) return;
  window.__revamNavbarInit = true;

  var OPEN_DELAY = 120;   // ms — intent delay before opening on hover
  var CLOSE_DELAY = 220;  // ms — grace period before closing on leave

  function init() {
    var navs = document.querySelectorAll('.revam-nav');
    if (!navs.length) return;

    navs.forEach(function (nav) {
      nav.setAttribute('data-revam-enhanced', '');
      var items = nav.querySelectorAll('.revam-nav__item[data-revam-has-menu]');

      function closeAll(except) {
        items.forEach(function (it) {
          if (it !== except) setOpen(it, false);
        });
      }

      items.forEach(function (item) {
        var trigger = item.querySelector('[data-revam-trigger]');
        var panel = item.querySelector('.revam-megamenu');
        if (!trigger || !panel) return;

        var openTimer, closeTimer;

        function scheduleOpen() {
          clearTimeout(closeTimer);
          openTimer = setTimeout(function () {
            closeAll(item);
            setOpen(item, true);
          }, OPEN_DELAY);
        }
        function scheduleClose() {
          clearTimeout(openTimer);
          closeTimer = setTimeout(function () { setOpen(item, false); }, CLOSE_DELAY);
        }

        item.addEventListener('mouseenter', scheduleOpen);
        item.addEventListener('mouseleave', scheduleClose);

        // Keyboard / focus: open immediately when focus enters, close when it leaves.
        item.addEventListener('focusin', function () {
          clearTimeout(closeTimer);
          closeAll(item);
          setOpen(item, true);
        });
        item.addEventListener('focusout', function (e) {
          if (!item.contains(e.relatedTarget)) setOpen(item, false);
        });

        // Esc closes the panel and returns focus to the trigger.
        item.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' || e.keyCode === 27) {
            if (item.getAttribute('data-open') === 'true') {
              setOpen(item, false);
              trigger.focus();
              e.stopPropagation();
            }
          }
        });
      });
    });

    // Click anywhere outside an open menu closes everything.
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.revam-nav__item[data-revam-has-menu]')) {
        document.querySelectorAll('.revam-nav__item[data-open="true"]').forEach(function (it) {
          setOpen(it, false);
        });
      }
    });
  }

  function setOpen(item, open) {
    item.setAttribute('data-open', open ? 'true' : 'false');
    var trigger = item.querySelector('[data-revam-trigger]');
    if (trigger) trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
